import { InvoiceListItemDTO, InvoicesResponseDTO } from "../models/InvoiceDTOs";
import {
  InvoiceListItemEntity,
  InvoicesResultEntity,
  PaginationInfo,
} from "../../domain/entities/InvoiceListItemEntity";

export class InvoiceMapper {
  static toEntity(dto: InvoiceListItemDTO): InvoiceListItemEntity {
    return {
      id: dto.id,
      invoice_id: dto.invoice_id,
      invoice_number: dto.invoice_number,
      date: dto.date,
      total: dto.total,
      currency_id: dto.currency_id,
      exchange_rate: dto.exchange_rate,
      tax_total: dto.tax_total,
      balance: dto.balance,
      unprocessed_payment_amount: dto.unprocessed_payment_amount,
      currency_code: dto.currency_code,
      currency_symbol: dto.currency_symbol,
      status: dto.status,
      is_tds_applied: dto.is_tds_applied,
      tds_tax_id: dto.tds_tax_id,
      tds_section: dto.tds_section,
      tds_tax_amount: dto.tds_tax_amount,
      tds_tax_percentage: dto.tds_tax_percentage,
      tds_tax_name: dto.tds_tax_name,
    };
  }

  static toResultEntity(dto: InvoicesResponseDTO): InvoicesResultEntity {
    return {
      items: dto.data.map((invoice) => this.toEntity(invoice)),
      pagination: dto.pagination as PaginationInfo,
    };
  }
}
